import gtagEventEmitter from "helpers/gtagEventEmitter";
import getKeywordsMap, { getKeywordsMapIcon } from "../constants";
import styles from "./CuratedReviewsStyles.module.scss";
import InfoIcon from "@Icons/InfoIcon";
import { useEffect, useState } from "react";
import Image from "@Components/Image";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import config from "@Config/index";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

const CuratedReviews = ({
  hasReviews = true,
  reviewSummary,
  inventoryName,
  isDesktop = false,
}: any) => {
  const { t } = useTranslationHook();
  const keywordsMap = getKeywordsMap(t);
  const keywordsMapIcon = getKeywordsMapIcon;
  let showRatings = false;
  const handleFeedbackButtonClick = (type: "thumbsUp" | "thumbsDown") => () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    gtagEventEmitter({
      action: type === "thumbsUp" ? "review_summary_thumbs_up" : "review_summary_thumbs_down",
      category: "curated_review_feedback",
      label: inventoryName,
    });
  };
  const [toolTip, setToolTip] = useState(false);
  useEffect(() => {
    document.addEventListener("click", (e: any) => {
      if (typeof e.target.className == "string" && !e.target.className.includes("toolTip")) {
        setToolTip(false);
      }
    });
  }, []);

  const sortedKeywords = Object.fromEntries(
    Object.entries(keywordsMap).sort(
      (a: any, b: any) =>
        parseFloat(reviewSummary?.rating?.[b[0]]) - parseFloat(reviewSummary?.rating?.[a[0]]),
    ),
  );
  Object.keys(sortedKeywords).forEach((keyword) => {
    if (reviewSummary?.rating?.[keyword] > 3.4) {
      showRatings = true;
    }
  });

  const sortedKeywordsForIcons = Object.fromEntries(
    Object.entries(keywordsMapIcon).sort(
      (a: any, b: any) =>
        parseFloat(reviewSummary?.rating?.[b[0]]) - parseFloat(reviewSummary?.rating?.[a[0]]),
    ),
  );
  Object.keys(sortedKeywordsForIcons).forEach((keyword) => {
    if (reviewSummary?.rating?.[keyword] > 3.4) {
      showRatings = true;
    }
  });
  return (
    <div className={formatClassNames(styles.container, isDesktop && styles.desktop)}>
      {isDesktop && (
        <div className={styles.titleContainer}>
          <div className={styles.title}>
            {t("propertypage.reviewssection.curatedreviews.summarytitle")}
          </div>
          <div
            className={styles.infoIconContainer}
            id="infoIconContainer"
            onClick={() => setToolTip(true)}
            role="none"
          >
            <InfoIcon />
          </div>
          {toolTip && (
            <div className={formatClassNames(styles.toolTip, isDesktop && styles.desktop)}>
              {t("propertypage.reviewssection.curatedreviews.tooltiptext")}
            </div>
          )}
        </div>
      )}
      {showRatings && (
        <div className={isDesktop ? styles.keywordsContainerDesktop : styles.keywordsContainer}>
          {Object.keys(sortedKeywordsForIcons).map((keyword) => (
            <>
              {reviewSummary?.rating?.[keyword] > 3.4 ? (
                <div className={isDesktop ? styles.keywordDesktop : styles.keyword} key={keyword}>
                  <div className={!isDesktop && styles.keywordWrapper}>
                    {!isDesktop && (
                      <div className={styles.reviewMobKeywordImage}>
                        <Image
                          src={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/${keywordsMapIcon?.[
                            keyword as keyof typeof keywordsMapIcon
                          ].replace("/", "")}${
                            keywordsMapIcon?.[keyword as keyof typeof keywordsMapIcon] ==
                            "Amenities"
                              ? "-review"
                              : ""
                          }.svg`}
                          height={16}
                          width="auto"
                          className={styles.ratingFeatureIcon}
                        />
                      </div>
                    )}
                    {t(keywordsMap?.[keyword])}
                  </div>
                  <div className={isDesktop ? styles.ratingDivDesktop : styles.ratingDiv}>
                    {reviewSummary?.rating?.[keyword] >= 3.5 && reviewSummary?.rating?.[keyword] < 4
                      ? "4.0"
                      : Number(reviewSummary?.rating?.[keyword]).toFixed(1)}
                  </div>
                  {isDesktop && (
                    <Image
                      src={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/${keywordsMapIcon?.[
                        keyword as keyof typeof keywordsMapIcon
                      ].replace("/", "")}${
                        keywordsMapIcon?.[keyword as keyof typeof keywordsMapIcon] == "Amenities"
                          ? "-review"
                          : ""
                      }.svg`}
                      height={24}
                      width="auto"
                      className={styles.ratingFeatureIcon}
                    />
                  )}
                </div>
              ) : (
                <></>
              )}
            </>
          ))}
        </div>
      )}
      {!isDesktop && (
        <div className={styles.titleContainer}>
          <div className={styles.title}>
            {t("propertypage.reviewssection.curatedreviews.summarytitle")}
          </div>
          <div
            className={styles.infoIconContainer}
            id="infoIconContainer"
            onClick={() => setToolTip(true)}
            role="none"
          >
            <InfoIcon />
          </div>
          {toolTip && (
            <div className={formatClassNames(styles.toolTip, isDesktop && styles.desktop)}>
              {t("propertypage.reviewssection.curatedreviews.tooltiptext")}
            </div>
          )}
        </div>
      )}
      <div>
        <div className={styles.review}>{reviewSummary?.summary}</div>
      </div>
      {!hasReviews && (
        <div className={styles.feedbackContainer}>
          <div className={styles.feedbackinnderDiv}>
            <div className={styles.feedbackText}>
              {t("propertypage.reviewssection.curatedreviews.feedbacktext")}
            </div>
            <Image
              height="auto"
              width="auto"
              src="https://prod-static-assets.amberstudent.com/images/emoji_u1f60d.svg?auto=format"
            />
          </div>
          <div className={styles.buttonContainer}>
            <button
              type="button"
              className={styles.feedbackButton}
              onClick={handleFeedbackButtonClick("thumbsUp")}
            >
              <Image
                height="16"
                width="16"
                src="https://prod-static-assets.amberstudent.com/images/thumbs-up-light.svg?auto=format"
                alt="thumbs up"
              />
            </button>
            <button
              className={styles.feedbackButton}
              onClick={handleFeedbackButtonClick("thumbsDown")}
              type="button"
            >
              <Image
                height="16"
                width="16"
                src="https://prod-static-assets.amberstudent.com/images/thumbs-down-light.svg?auto=format"
                alt="thumbs down"
              />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default wrapperHOC(CuratedReviews, {
  componentName: "CuratedReviews-ReviewsSection-PropertyPage",
  showForChina: true,
});
